import React, { CSSProperties } from 'react';
import { RetailerTheme } from '../../../__generated__/loma';

export type RetailerThemeStyles = Partial<
  Record<keyof Omit<RetailerTheme, '__typename'>, CSSProperties>
>;

interface ThemeProviderValue {
  theme: RetailerThemeStyles;
}

interface ThemeProviderProps {
  value: ThemeProviderValue;
}

const ThemeContext = React.createContext<ThemeProviderValue>({
  theme: {},
});

export const ThemeProvider: React.FC<
  React.PropsWithChildren<ThemeProviderProps>
> = ({ children, value: { theme } }) => {
  return (
    <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = React.useContext(ThemeContext);
  if (!context) throw new Error('useTheme was called without a ThemeContext');
  return context.theme;
};
